export default __webpack_public_path__ + "static/media/banner.9092b819.jpg";